import { render, staticRenderFns } from "./SemaforoVermelho.vue?vue&type=template&id=4d93a6ec&scoped=true&"
import script from "./SemaforoVermelho.vue?vue&type=script&lang=js&"
export * from "./SemaforoVermelho.vue?vue&type=script&lang=js&"
import style0 from "./SemaforoVermelho.vue?vue&type=style&index=0&id=4d93a6ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93a6ec",
  null
  
)

export default component.exports